import styles from './styles.module.css'
import React, {useState} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding, faChevronDown, faChevronUp, faCircleChevronLeft, faComment, faComments, faDatabase, faFileLines, faGem, faGripVertical, faHeadphones, faLink, faListAlt, faMessage, faMicrophone, faMicrophoneAlt, faMicrophoneLines, faPlus, faRectangleList, faRightFromBracket, faStar, faUsers, faTasks, faFileAlt, faThLarge, faAddressCard, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { BreadcrumbItem, Collapse } from 'react-bootstrap';
import Toggle from '../../assets/images/sidebar-toogle.svg'

const New = () => {
    const [openJobs, setOpenJobs] = useState(false);
  const [openInternships, setOpenInternships] = useState(false);
  const [openAdmin, setOpenAdmin] = useState(false);
  const [isRightbarExpanded, setRightbarExpanded] = useState(false);

  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };
  const toggleRightbar = () => {
    setRightbarExpanded((prev) => !prev);
  };
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  const [showDiv, setShowDiv] = useState(true);
  const [addClass, setAddClass] = useState(false);
  const handleSkip = () => {
    setShowDiv(false);
    setAddClass(true);
  };
const [activeIndex, setActiveIndex] = useState(null);
  const menuItems = [
          { name: "Jobs", icon: faListAlt },
          { name: "Documents", icon: faFileAlt },
          { name: "Database", icon: faDatabase },
          { name: "Users", icon: faUsers },
          { name: "Apps", icon: faThLarge },
      ];
  return (
    <section>
        <div className='container-fluid'>
            <div className='row mview-none'>
                <div className='col-md-12'>
                {showDiv && (
                    <div className='mb-3 bg'>
                        <div className={`${styles['demo-card']} card`}>
                            <div className='card-body'>
                                <div className='d-flex justify-content-between'>
                                    <h1>Experience Our Product Live!</h1>
                                    <a className={`${styles['book-btn']} btn`} href='#'>Book a Demo Now</a>
                                </div>
                                <div className='d-flex justify-content-between'>
                                    <p className='mb-0 w-75'>Schedule a free live training session with one of our product experts to discover how you can optimize your organization's hiring process. See our innovative solution in action and learn how it can transform your recruitment strategy.</p>
                                    <p className='mt-5 mb-0'><a className={`${styles['skip-btn']} btn`} href='#' onClick={handleSkip}>Skip</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    )}
                </div>
                <div className='col-md-12'>
                    
                </div>
            </div>
            <div className='row mb-3'>
                <div className={`${styles['mw-33']} col-md-4`}>
                    <div className={`${styles['custom-card']} text-start`}>
                    <div className='d-flex justify-content-between align-items-center'>
                    <div className={`${styles['re-title']} text-title`}>
                        <h4 className='mb-1'>Regular Jobs</h4>
                        <h5 className='mb-0'>3 out of 5</h5>
                    </div>
                    <div className={`${styles['icon-container']}`}>
                            <FontAwesomeIcon icon={faListAlt}/>
                    </div>
                    </div>
                    </div>
                </div>
                <div className={`${styles['mw-33']} col-md-4`}>
                <div className={`${styles['feature-card']} text-start`}>
                    <div className='d-flex justify-content-between align-items-center'>
                    <div className={`${styles['re-title']} text-title`}>
                        <h4 className='mb-1'>Feature Jobs</h4>
                        <h5 className='mb-0'>3 out of 5</h5>
                    </div>
                    <div className={`${styles['icon-container']}`}>
                            <FontAwesomeIcon icon={faStar}/>
                    </div>
                    </div>
                    </div>
                </div>
                <div className={`${styles['mw-33']} col-md-4`}>
                <div className={`${styles['premium-card']} text-start`}>
                    <div className='d-flex justify-content-between align-items-center'>
                    <div className={`${styles['re-title']} text-title`}>
                        <h4 className='mb-1'>Premium Jobs</h4>
                        <h5 className='mb-0'>3 out of 5</h5>
                    </div>
                    <div className={`${styles['icon-container']}`}>
                            <FontAwesomeIcon icon={faGem}/>
                    </div>
                    </div>
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='col-md-12'>
                    <div className={`${styles['filter-box']}`}>
                        <ul className={`${styles['filter-list']}`}>
                            <li><a className={`${styles['list-active']}`} href='#'>Live<span>(12)</span></a></li>
                            <li><a href='#'>Incomplete<span>(4)</span></a></li>
                            <li><a href='#'>Inactive / Expired <span>(7)</span></a></li>
                        </ul>
                        <select className={`${styles['filter-select']} rounded-pill form-select`} aria-label="Default select example">
                            <option selected>Filter by Job type</option>
                            <option value="1">One</option>
                            <option value="2">Two</option>
                            <option value="3">Three</option>
                        </select>
                    </div>
                </div>
                <div className='col-md-12'>
                    <div className={`${styles['job-lists']}`}>
                        <div className='row'>
                            <div className='col-md-12'>
                            <div className="d-flex justify-content-between align-items-center mb-3">
                            <h3 className={`${styles['intern-heading']}`}>All Jobs and Internships</h3>
                            <div className='position-relative'>
                            <button className={`${styles['book-btn']} btn`} onClick={toggleDropdown}><span className={`${styles['dd-view']}`}>Post a New Job</span><span className={`${styles['mm-view']}`}><FontAwesomeIcon icon={faPlus}/></span></button>
                            <div className={`dropdown-menu ${styles['ctmdropdown-menu']} ${isOpen ? "show" : ""}`}>
                                <div className={`${styles['ctmdropdown-option']} ${styles['ctmdropdown-optionhover']}`}>
                                    <span className={`${styles['icon-address']}`}><FontAwesomeIcon icon={faAddressCard}/></span>
                                    <div className={`${styles['details-ctm']}`}>
                                        <h4>Start with new post</h4>
                                        <h5>Fill the form and Create Job Post</h5>
                                    </div>
                                    <div className='d-flex'>
                                        <FontAwesomeIcon className={`${styles['arrow-right']}`} icon={faChevronRight}/>
                                    </div>
                                </div>
                                <hr/>
                                <div className={`${styles['ctmdropdown-option']} ${styles['ctmdropdown-optiontwhover']}`}>
                                    <span className={`${styles['icon-address']} text-warning`}><FontAwesomeIcon icon={faAddressCard}/></span>
                                    <div className={`${styles['details-ctm']} w-85`}>
                                        <h4 className={`${styles['ctm-yellow']}`}>Post with Previously Posted Requirement</h4>
                                        <h5>(AI-Powered Job Description Generator)</h5>
                                        <span>Save 80% more time</span>
                                    </div>
                                    <div className='d-flex'>
                                        <FontAwesomeIcon icon={faChevronRight}/>
                                    </div>
                                </div>
                            </div>
                            </div>
                            </div>
                            <div className={`${styles['all-lists']} ${addClass ? "new-class" : ""}`}>
                            <div className="card mb-3">
                                <div className="card-body">
                                    <div className='row'>
                                        <div className='col-md-12'>
                                            <h5 className={`${styles['card-titletext']}`}>Product Manager <span className={`${styles['badge-list']}`}>FEATURED JOBS</span></h5>
                                        </div>
                                        <div className='col-md-12'>
                                            <div className='row'>
                                                <div className='col-sm-7'>
                                                    <p className={`${styles['card-text']}`}>Hydrabad, 28/08/2024, Akshay</p>
                                                </div>
                                                <div className='col-sm-5'>
                                                    <div className='d-flex justify-content-between'>
                                                        <div className={`${styles['application-status']}`}>10 Applications Received</div>
                                                        <a href='#'><FontAwesomeIcon className={`${styles['icon-list']}`} icon={faComments}/></a>
                                                        <a href='#'><FontAwesomeIcon className={`${styles['icon-list']}`} icon={faLink}/></a>
                                                        <select className={`${styles['select-list']} form-select`} aria-label="Default select example">
                                                            <option selected>Open</option>
                                                            <option value="1">One</option>
                                                            <option value="2">Two</option>
                                                            <option value="3">Three</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card mb-3">
                            <div className="card-body">
                                    <div className='row'>
                                        <div className='col-md-12'>
                                            <h5 className={`${styles['card-titletext']}`}>Full Stack Developer <span className={`${styles['badge-listsec']}`}>Premium Jobs</span></h5>
                                        </div>
                                        <div className='col-md-12'>
                                            <div className='row'>
                                                <div className='col-sm-7'>
                                                    <p className={`${styles['card-text']}`}>Hydrabad, 28/08/2024, Akshay</p>
                                                </div>
                                                <div className='col-sm-5'>
                                                    <div className='d-flex justify-content-between'>
                                                        <div className={`${styles['application-status']}`}>10 Applications Received</div>
                                                        <a href='#'><FontAwesomeIcon className={`${styles['icon-list']}`} icon={faComments}/></a>
                                                        <a href='#'><FontAwesomeIcon className={`${styles['icon-list']}`} icon={faLink}/></a>
                                                        <select className={`${styles['select-list']} form-select`} aria-label="Default select example">
                                                            <option selected>Open</option>
                                                            <option value="1">One</option>
                                                            <option value="2">Two</option>
                                                            <option value="3">Three</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card mb-3">
                            <div className="card-body">
                                    <div className='row'>
                                        <div className='col-md-12'>
                                            <h5 className={`${styles['card-titletext']}`}>Digital Marketing Expert <span className={`${styles['badge-list']}`}>FEATURED JOBS</span></h5>
                                        </div>
                                        <div className='col-md-12'>
                                            <div className='row'>
                                                <div className='col-sm-7'>
                                                    <p className={`${styles['card-text']}`}>Hydrabad, 28/08/2024, Akshay</p>
                                                </div>
                                                <div className='col-sm-5'>
                                                    <div className='d-flex justify-content-between'>
                                                        <div className={`${styles['application-status']}`}>10 Applications Received</div>
                                                        <a href='#'><FontAwesomeIcon className={`${styles['icon-list']}`} icon={faComments}/></a>
                                                        <a href='#'><FontAwesomeIcon className={`${styles['icon-list']}`} icon={faLink}/></a>
                                                        <select className={`${styles['select-listclose']} form-select`} aria-label="Default select example">
                                                            <option selected>Closed</option>
                                                            <option value="1">One</option>
                                                            <option value="2">Two</option>
                                                            <option value="3">Three</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        <div className={`${styles['mobile-view']} container`}>
                <div className='row'>
                    <div className='col-md-12'>
                    <nav className={`${styles['menu-container']}`}>
                    <ul className={`${styles['menu-list']}`}>
                        {menuItems.map((item, index) => (
                            <li
                                key={index}
                                className={`${styles['menu-item']} ${activeIndex === index ? "active" : ""}`}
                                onClick={() => setActiveIndex(index)}
                            >
                                <FontAwesomeIcon icon={item.icon} className={`${styles["menu-icon"]} ${ activeIndex === index ? styles["active-icon"] : "" }`} />
                                {activeIndex === index && <span className={`${styles['menu-text']}`}>{item.name}</span>}
                            </li>
                        ))}
                    </ul>
                </nav>
                    </div>
                    
                </div>
            </div>
    </section>
  )
}

export default New